import React from "react";
import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/logo.png';
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {

    const { t, i18n } = useTranslation();
    return (
        <>
            {/* <div className={`main-container ${styles.footerContainer}`}>
                <div className={`container-content ${styles.footer}`}>
                    <div className={styles.upperFooter}>
                        <div className={styles.upperFooterleft}>
                            <div className={styles.leftFooterTitle}>
                                SUBSCRIBE NOW & <span className={styles.yellowText}>WIN BIG</span> - IT'S EASY!
                            </div>
                            <div className={styles.leftFooterButton}>
                                <button type="button" className={styles.regBtn}>Register</button>
                            </div>
                        </div>
                        <div className={styles.upperFooterRight}>
                            <img src={CarTicketsImg} />
                        </div>
                    </div>
                </div>
            </div> */}
            <div className={`main-container ${styles.footerContainerBottom}`}>
                <div className={`container-content ${styles.footer}`}>
                    <div className={styles.bottomFooter}>
                        <div className={styles.bottomFooterUpper}>
                            <div className={styles.logoSec}>
                                <Link to="/">
                                    <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                                </Link>
                            </div>
                            <ul className={styles.navList}>
                                <li>  <Link to="/about" className={`${styles.footerLink} ${i18n.language === 'ta' ? `tamil-link` : ""}`}>{t(`About Us`)}</Link></li>
                                <li> <Link to="/contact" className={`${styles.footerLink} ${i18n.language === 'ta' ? `tamil-link` : ""}`}>{t(`Contact`)}</Link></li>
                                <li> <Link to="/privacy-policy" className={`${styles.footerLink} ${i18n.language === 'ta' ? `tamil-link` : ""}`}>{t(`Privacy Policy`)}</Link></li>
                                <li> <Link to="/terms-and-conditions" className={`${styles.footerLink} ${i18n.language === 'ta' ? `tamil-link` : ""}`}>{t(`Terms`)}</Link></li>
                            </ul>
                        </div>
                        <div className={styles.bottomFooterLower}>
                            Copyright © {new Date().getFullYear()} MyLottery LK. All Rights Reserved.
                            Designed and Developed by{" "}
                            <a
                                href="https://prideconsultationcenter.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none", color: "inherit" }}
                            >
                                Pride CC
                            </a>.
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer;